import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';

import { BrowserHelpers } from '../../../_helpers/BrowserHelpers';
import { MessageService } from '../../../_services/local/message.service';
import { MainStoreState } from '../../../_store/mainStoreState';
import { getCurrentUser } from '../../../_store/AccountStore/account.store';
import { AccountService } from '../../../_services/http/account.service';
import { KafkaHealthService } from '../../../_services/http/kafka-health.service';
import { AdminConsoleComponent } from '../../admin-console/admin-console.component';
import { DashboardService } from '../../dashboard/dashboard.service';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
})
export class UserProfileComponent implements OnInit {
  @Output('themeChanged') themeChanged = new EventEmitter<'dark' | 'light'>();

  private readonly pickerOpts = {
    types: [
      {
        description: 'Config file',
        accept: {
          'config/*': ['.json'],
        },
      },
    ],
    excludeAcceptAllOption: true,
    multiple: false,
  };

  private fileHandle: any;
  private verru!: HTMLDivElement | null;

  dark!: HTMLLinkElement | null;
  light!: HTMLLinkElement | null;

  theme = BrowserHelpers.isDarkTheme() ? 'light' : 'dark';
  user$ = this.store.select(getCurrentUser);

  constructor(
    private ds: DashboardService,
    private store: Store<MainStoreState>,
    private router: Router,
    private accountService: AccountService,
    private messageService: MessageService,
    private dialog: MatDialog,
    public kafkaService: KafkaHealthService
  ) {}

  ngOnInit(): void {
    this.dark = document.querySelector<HTMLLinkElement>('#jsapi-theme-dark');
    this.light = document.querySelector<HTMLLinkElement>('#jsapi-theme-light');
    this.updateTheme();
  }

  async loadConfiguration(): Promise<void> {
    try {
      // @ts-ignore
      const handlers = await window.showOpenFilePicker(this.pickerOpts);
      if (handlers.length > 0) {
        this.fileHandle = handlers[0];
        const file = await this.fileHandle.getFile();
        const content = await file.text();
        const config = JSON.parse(content);
        this.ds.loadDashboard(config);
      }
    } catch (error: any) {
      console.warn(error);
      if (error && error.code !== 20) {
        this.messageService.info('Impossible de charger la configuration');
      }
    }
  }

  saveConfiguration(): void {
    this.ds.saveDashboard();
  }

  updateTheme(): void {
    this.verru = document.querySelector<HTMLDivElement>('.esri-ui');

    if (this.theme === 'light') {
      document.body.classList.add('arx-dark-theme');
      document.body.classList.remove('calcite-theme-light');
      document.body.classList.add('calcite-theme-dark');
      this.theme = 'dark';
      if (this.dark && this.light) {
        this.dark.disabled = false;
        this.light.disabled = true;
      }
      if (this.verru) {
        this.verru.classList.remove('calcite-theme-light');
      }
      this.themeChanged.emit('dark');
    } else {
      document.body.classList.remove('arx-dark-theme');
      document.body.classList.remove('calcite-theme-dark');
      document.body.classList.add('calcite-theme-light');
      this.theme = 'light';
      if (this.dark && this.light) {
        this.light.disabled = false;
        this.dark.disabled = true;
      }
      if (this.verru) {
        this.verru.classList.remove('calcite-theme-dark');
      }
      this.themeChanged.emit('light');
    }
  }

  logout(): void {
    this.accountService.logout().subscribe((response) => {
      if (response) {
        if ('redirectUrl' in response) {
          window.location.href = response.redirectUrl;
        }
      }
    });
  }

  toggleConsoleAdmin() {
    this.dialog.open(AdminConsoleComponent, {
      width: '95%',
      height: '90%',
    });
  }
}
